import React from 'react';
import { Star, TrendingUp, Users, Clock } from 'lucide-react';

const SocialProof = () => {
  const stats = [
    {
      icon: Users,
      number: "200+",
      label: "Businesses served"
    },
    {
      icon: TrendingUp,
      number: "80%",
      label: "Cost reduction average"
    },
    {
      icon: Clock,
      number: "24/7",
      label: "Uptime guarantee"
    },
    {
      icon: Star,
      number: "4.9",
      label: "Customer satisfaction"
    }
  ];

  const testimonials = [
    {
      quote: "Increased our bookings by 45% in the first month. The AI handles everything while we sleep.",
      author: "Maria Rodriguez",
      business: "Casa Bella Restaurant",
      result: "+45% bookings"
    },
    {
      quote: "Cut our phone support costs by 70%. Customers love the instant responses.",
      author: "James Chen", 
      business: "TechFix Solutions",
      result: "-70% support costs"
    }
  ];

  return (
    <>
    <div className="thunder-divider">
      <svg className="thunder-line" viewBox="0 0 100 20" preserveAspectRatio="none">
        <path d="M0,10 L20,10 L25,5 L30,15 L35,5 L40,15 L45,10 L100,10" stroke="currentColor" fill="none" strokeWidth="2"/>
      </svg>
    </div>
    <section id="buzz" className="section social-proof-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Buzz</h2>
        </div>
        {/* Stats Row */}
        <div className="stats-grid">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div key={index} className="stat-card">
                <div className="stat-icon">
                  <IconComponent size={32} />
                </div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            );
          })}
        </div>

        {/* Testimonials */}
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-quote">"{testimonial.quote}"</div>
              <div className="testimonial-author">
                <div className="author-info">
                  <div className="author-name">{testimonial.author}</div>
                  <div className="author-business">{testimonial.business}</div>
                </div>
                <div className="testimonial-result">{testimonial.result}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default SocialProof;